import { enumToI18nKey } from '~/utils/helpers';

export const WALLET_TYPE = {
  MASTER_PASS: 'MasterPass',
  APPLE_PAY: 'ApplePay',
  GOOGLE_PAY: 'GooglePay'
} as { [key: string]: WalletsApi.eWalletType }

export const WALLET_TYPE_I18n = enumToI18nKey(WALLET_TYPE, 'WALLET_TYPE');
